import { createReducer } from '@reduxjs/toolkit';
import { IUser } from '../../../interfaces/user';
import { getAdminUsersAction, resetAdminDevelopers } from '../actions/AdminUserActions';

export interface ReduxAdminUsersState {
  developers?: IUser[];
  developersLoaded?: boolean;
  developersFetched?: Date;
}

const initialState: ReduxAdminUsersState = {
  developers: [],
  developersLoaded: false,
};

const adminUserReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(getAdminUsersAction, (state, action) => ({
      ...state,
      developers: action.payload,
      developersLoaded: true,
      developersFetched: new Date(Date.now()),
    }))
    .addCase(resetAdminDevelopers, (state) => ({
      ...state,
      developers: undefined,
      developersLoaded: false,
      developersFetched: undefined,
    })),
);

export default adminUserReducer;
